import { Queue } from '../graphql/components';

export const getQueue = (queues: Queue[], id: string) => queues.find((queue) => queue.id === id);
